import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CallIcon from '@mui/icons-material/Call'; 
import FaxIcon from '@mui/icons-material/Fax';
import EmailIcon from '@mui/icons-material/Email';
import { AppBar, Container, useMediaQuery, useTheme } from '@mui/material';

function InfoBar() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <AppBar  
            elevation={0}
            sx={{
                height: '25px', 
                position: 'fixed', 
                backgroundColor: '#694400',
            }}
        >
            <Container maxWidth='xl'>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '3px'}}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                            <CallIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                02 408 9488-9
                            </Typography>
                            {!isSmallScreen && (<Typography variant="caption" sx={{ ml: 0.5 }}>, 086 366 0298, (098) 935 5858</Typography> )}
                        </Box>
                        {!isSmallScreen && ( // Render FaxIcon and info only if not small screen
                            <Box sx={{ display: 'flex', alignItems: 'center', mx: 1 }}>
                                <FaxIcon fontSize='small' />
                                <Typography variant="caption" sx={{ ml: 0.5 }}>
                                    02 408 9490
                                </Typography>
                            </Box>
                        )}
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                            <EmailIcon fontSize='small' />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                hopbon1999@gmail.com
                            </Typography>
                        </Box>
                        
                    </Box>
                </Box>
            </Container>
        </AppBar>
    );
}

export default InfoBar;
